// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__32g5L","value":"styles_value__1sQRF","smallValue":"styles_smallValue__K4MoM","moscowExport":"styles_moscowExport__2KWJU"};